import { Card as MuiCard, Box, Button, CssBaseline, Divider, FormControl, FormLabel, TextField, Typography, IconButton, InputAdornment } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react';
import { ILoginForm } from '../../../../types/auth';
import { Mixpanel } from '../../../../util/mixpanel';
import { startLogin } from '../../../../redux/actions/auth';
import { Controller, useForm } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import logo from '../../../../assets/logo.png'
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { UserType } from '../../../../constants/data';
const useStyles = makeStyles((theme) => ({
    card: {
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'center',
        width: '100%',
        maxWidth: '500px',
        padding: theme.spacing(4),
        gap: '8px',
        margin: 'auto',
        boxShadow:
            'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
        borderRadius: theme.spacing(1),
        backgroundColor: '#FFF'
    },
    textField: {
        width: '100%',
        backgroundColor: '#F5F5F5',
        borderRadius: '10px'
    },
    container: {
        display: 'flex',
        justifyContent: 'center',
        minHeight: '100vh',
        alignItems: 'center',
        backgroundColor: '#EDF2F7',
        padding: theme.spacing(2),
    },
    title: {
        fontSize: '2.75rem',
        fontWeight: 700,
        textAlign: 'center',
        marginBottom: theme.spacing(2)
    },
    subTitle: {
        fontFamily: 'MontserratRegular',
        fontWeight: 400,
        fontSize: '20px',
        lineHeight: '28.79px',
        color: '#000000',
        marginBottom: '18px',
        textAlign: 'center'

    },

    titlePara: {
        fontSize: '1rem',
        color: '#49475A',
        textAlign: 'center',
        marginBottom: theme.spacing(2),
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        '& .MuiOutlinedInput-root': {
            borderRadius: 6
        },
        '& .MuiFormLabel-root': {
            color: '#9794AA',
            marginBottom: theme.spacing(1),
        }
    },
    dividerContainer: {
        display: 'flex',
        alignItems: 'center',
        margin: `${theme.spacing(1)}px 0`,
    },
    dividerLine: {
        flexGrow: 1,
        height: '1px',
        backgroundColor: theme.palette.divider,
    },
    dividerText: {
        margin: `0 ${theme.spacing(1)}px`,
        color: '#706C7C',
        fontWeight: 600,
        fontSize: 18
    },
    submitBtn: {
        background: '#5C91FF',
        color: '#fff',
        textTransform: 'capitalize',
        borderRadius: 6,
        padding: '11px 11px',
        marginBottom: theme.spacing(2),
        '&:hover': {
            background: '#5C91FF'
        },
    },
    socialLogin: {
        display: 'flex',
        justifyContent: 'center',
        gap: theme.spacing(1),
    },
    paragraphText: {
        display: 'block',
        textAlign: 'center',
        color: '#000000',
        fontWeight: 400,
        fontSize: '20px',
        lineHeight: '28.79px',
        fontFamily: 'MontserratRegular',
    },
    textLabel: {
        color: "#2158D0",
        display: 'block',
        textAlign: 'right',
        fontWeight: 700,
        fontSize: '20px',
        lineHeight: '28.79px',
        fontFamily: 'MontserratRegular',
        marginTop: '-20px',
        textDecoration: 'none'

    },
    formLabel: {
        color: "#2158D0",
        display: 'block',
        textAlign: 'left',
        fontWeight: 700,
        fontSize: '20px',
        lineHeight: '28.79px',
        fontFamily: 'MontserratRegular',
        marginTop: '0px',
        marginBottom: "-15px"
    },
    singupLink: {
        color: "#2158D0",
        cursor: 'pointer',
        textDecoration: 'none'
    },



}));

interface PropsType {
    loginLoader: boolean;
    authError: string;
    startLogin: (authData: ILoginForm) => any;
}

export default function Login() {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false)
    const history = useHistory();
    useEffect(() => {
        Mixpanel.reset();
    }, [])

    const onSubmit = async (data: any) => {
        setLoading(true)
        const loginResponse: any = await dispatch(startLogin(data));
        setLoading(false)
        if (loginResponse.success) {
            const userData = loginResponse?.userData
            if ((userData?.data?.type === UserType.admin || userData?.data?.type === UserType.teamAdmin)) {
                history.push(`/admin/dashboard`)
            }
            else {
                history.push(`/user/dashboard`)
            }
        }

    };

    const { control, handleSubmit, errors } = useForm();
    const handleClickShowPassword = () => {
        setShowPassword((prev) => !prev);
    };
    return (
        <>
            <CssBaseline />
            <div className={classes.container}>
                {
                    loading ? <div className="loader-container">
                        <div className="loader"></div>
                    </div>
                        :

                        <MuiCard className={classes.card}>
                            <Typography variant="h1" className={classes.title}>
                                <div>

                                    <img
                                        style={{ width: 280 }}
                                        src={logo}
                                        alt="Logo"
                                    />
                                </div>
                            </Typography>
                            <Typography className={classes.subTitle}>
                                {/* Welcome to {inviteProgramText ? `${inviteProgramText} Program` : 'CommunityReach'} */}
                                Please Sign in to your Community
                            </Typography>
                            {/* <Typography className={classes.titlePara}> */}
                            {/* Kindly fill in your details below to login */}
                            {/* Please Sign in to your Community */}
                            {/* </Typography> */}
                            <Box
                                component="form"
                                onSubmit={handleSubmit(onSubmit)}
                                className={classes.form}
                            >
                                <Typography variant="body1" className={classes.formLabel}>
                                    Email
                                </Typography>

                                <Controller
                                    className={classes.textField}
                                    variant="outlined"
                                    name="email"
                                    control={control}
                                    rules={{
                                        required: 'Email is  required.',
                                    }}
                                    defaultValue=""
                                    as={
                                        <TextField
                                            // label="Phone Number"
                                            required
                                            fullWidth
                                            placeholder="Email"
                                            name="email"
                                            variant="outlined"
                                            autoComplete="email"
                                            type="email"
                                        />
                                    }
                                />
                                <ErrorMessage
                                    as={<Typography color="error" />}
                                    errors={errors}
                                    name="email"
                                />
                                <Typography variant="body1" className={classes.formLabel}>
                                    Password
                                </Typography>

                                <Controller
                                    className={classes.textField} variant="outlined"
                                    name="password"
                                    control={control}
                                    rules={{
                                        required: 'Password is required.',
                                    }}
                                    defaultValue=""
                                    as={
                                        <TextField
                                            // label="Password"
                                            required
                                            fullWidth
                                            placeholder="Password"
                                            name="password"
                                            variant="outlined"
                                            type={showPassword ? 'text' : 'password'}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="toggle password visibility"
                                                            onClick={handleClickShowPassword}
                                                            edge="end"
                                                        >
                                                            {showPassword ? <Visibility /> : <VisibilityOff />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    }
                                />

                                <Button
                                    type="submit"
                                    fullWidth
                                    size="small"
                                    className={classes.submitBtn}
                                >
                                    Login
                                </Button>
                            </Box>
                            <Link to="/forgot-password" className={classes.textLabel} >
                                Forgot Password?
                            </Link>
                            <Box className={classes.dividerContainer}>
                                <div className={classes.dividerLine}></div>
                                <span className={classes.dividerText}>OR</span>
                                <div className={classes.dividerLine}></div>
                            </Box>

                            {/* Screen form Admin */}
                            {/* <Typography align="center" className={classes.paragraphText}>
                        Login using your social account{' '}
                    </Typography>

                    <div className={classes.socialLogin}>
                        <IconButton>
                            <InstagramIcon />
                        </IconButton>
                        <IconButton>
                        <GoogleIcon />
                        </IconButton>
                        <IconButton>
                        <FaceBookIcon />
                        </IconButton>
                    </div>  */}

                            {/* screen for member */}
                            <Typography align="center" className={classes.paragraphText}>
                                Don't have an account{' '}?  <Link to="/register" className={classes.singupLink} >
                                    <span className={classes.singupLink}>SignUp</span>
                                </Link>
                            </Typography>

                            <Typography align="center" className={classes.paragraphText} style={{ marginTop: 8 }}>
                                Want to start a new community?{' '}
                                <Link to="/setup" className={classes.singupLink}>
                                    <span className={classes.singupLink}>Get started</span>
                                </Link>
                            </Typography>

                        </MuiCard>
                }
            </div>


        </>
    );
}
